import { useMutation } from '@apollo/client';
import DELETE_EPUB_ANNOTATION from 'graphql/mutations/epubAnnotations/DeleteEpubAnnotation.graphql';
import { getIDFromPK } from 'utilities';

function _epubAnnotationsFieldMethod(deleteEpubAnnotation) {
  return (existingAnnotations, { readField }) => {
    const id = getIDFromPK(
      deleteEpubAnnotation.epubAnnotationId,
      'EpubAnnotationNode',
    );
    const cacheId = `EpubAnnotationNode:${id}`;
    const updatedEdges = existingAnnotations.edges.filter(
      (existingAnnotation) => cacheId !== existingAnnotation.node.__ref,
    );

    return {
      __typename: existingAnnotations.__typeName,
      edges: updatedEdges,
    };
  };
}

export default function useDeleteEpubAnnotationMutation() {
  return useMutation(DELETE_EPUB_ANNOTATION, {
    update(cache, { data: { deleteEpubAnnotation } }) {
      if (!deleteEpubAnnotation) {
        console.warn(
          'Failed to delete an EpubAnnotation record through GraphQL. It may not exist in the database.',
        );

        return;
      }

      cache.modify({
        fields: {
          epubAnnotationsInDocument:
            _epubAnnotationsFieldMethod(deleteEpubAnnotation),
          epubAnnotationsNotInDocument:
            _epubAnnotationsFieldMethod(deleteEpubAnnotation),
        },
      });
    },
  });
}
